const consultantSlab = {
  minAmount: 0,
  maxAmount: Infinity,
  taxPercent: 0.1,
  cessPercent: 0.04,
  minTaxAmount: 0,
};

const regularSlabBasic = {
  minAmount: 0,
  maxAmount: 250000,
  taxPercent: 0,
  cessPercent: 0,
  minTaxAmount: 0,
};

const regularSlabModerate = {
  minAmount: 250000,
  maxAmount: 500000,
  taxPercent: 0.05,
  cessPercent: 0.04,
  minTaxAmount: 0,
};

const regularSlabHigh = {
  minAmount: 500000,
  maxAmount: 1000000,
  taxPercent: 0.2,
  cessPercent: 0.04,
  minTaxAmount: 11250,
};

const regularSlabSuper = {
  minAmount: 1000000,
  maxAmount: Infinity,
  taxPercent: 0.3,
  cessPercent: 0.04,
  minTaxAmount: 112500,
};

const regularSlabsCollection = {
  basic: {
    ...regularSlabBasic,
  },
  moderate: {
    ...regularSlabModerate,
  },
  high: {
    ...regularSlabHigh,
  },
  super: {
    ...regularSlabSuper,
  },
};

const seniorSlabBasic = {
  minAmount: 0,
  maxAmount: 300000,
  taxPercent: 0,
  cessPercent: 0,
  minTaxAmount: 0,
};

const seniorSlabModerate = {
  minAmount: 300000,
  maxAmount: 500000,
  taxPercent: 0.05,
  cessPercent: 0.04,
  minTaxAmount: 0,
};

const seniorSlabHigh = {
  minAmount: 500000,
  maxAmount: 1000000,
  taxPercent: 0.2,
  cessPercent: 0.04,
  minTaxAmount: 10000,
};

const seniorSlabSuper = {
  minAmount: 1000000,
  maxAmount: Infinity,
  taxPercent: 0.3,
  cessPercent: 0.04,
  minTaxAmount: 110000,
};

const seniorSlabsCollection = {
  basic: {
    ...seniorSlabBasic,
  },
  moderate: {
    ...seniorSlabModerate,
  },
  high: {
    ...seniorSlabHigh,
  },
  super: {
    ...seniorSlabSuper,
  },
};

const superSeniorSlabBasic = {
  minAmount: 0,
  maxAmount: 500000,
  taxPercent: 0,
  cessPercent: 0,
  minTaxAmount: 0,
};

const superSeniorSlabModerate = {
  minAmount: 500000,
  maxAmount: 1000000,
  taxPercent: 0.2,
  cessPercent: 0.04,
  minTaxAmount: 0,
};

const superSeniorSlabHigh = {
  minAmount: 1000000,
  maxAmount: Infinity,
  taxPercent: 0.3,
  cessPercent: 0.04,
  minTaxAmount: 100000,
};

const superSeniorSlabsCollection = {
  basic: {
    ...superSeniorSlabBasic,
  },
  moderate: {
    ...superSeniorSlabModerate,
  },
  high: {
    ...superSeniorSlabHigh,
  },
};

export default {
  budget_20192020: {
    standardDeduction: 40000,
    maxDeduction: 0,
    groupRegular: {
      minAge: 0,
      maxAge: 60,
      slabs: {
        ...regularSlabsCollection,
      },
    },
    groupSenior: {
      minAge: 60,
      maxAge: 80,
      slabs: {
        ...seniorSlabsCollection,
      },
    },
    groupSuperSenior: {
      minAge: 80,
      maxAge: Infinity,
      slabs: {
        ...superSeniorSlabsCollection,
      },
    },
    groupConsultant: {
      minAge: 0,
      maxAge: Infinity,
      slabs: {
        consultant: {
          ...consultantSlab,
        },
      },
    },
  },
  budget_20202021: {
    standardDeduction: 50000,
    maxDeduction: 0,
    groupRegular: {
      minAge: 0,
      maxAge: 60,
      slabs: {
        ...regularSlabsCollection,
      },
    },
    groupSenior: {
      minAge: 60,
      maxAge: 80,
      slabs: {
        ...seniorSlabsCollection,
      },
    },
    groupSuperSenior: {
      minAge: 80,
      maxAge: Infinity,
      slabs: {
        ...superSeniorSlabsCollection,
      },
    },
    groupConsultant: {
      minAge: 0,
      maxAge: Infinity,
      slabs: {
        consultant: {
          ...consultantSlab,
        },
      },
    },
  },
};
